export enum CollectionPath {
  CHANNELS = "channels",
  COMPANIES = "companies",
  MESSAGES = "messages",
  ORGANIZATIONS = "externalChats",
  ORGANIZATION_SUGGESTIONS = "externalChatOrganizationSuggestions",
  PROFILES = "profiles",
  USER_STATES = "externalChatUserStates",
  USERS = "users",
  USER_STATUSES = "userStatus",
}
